/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL29wdC9qZW5raW5zL3dvcmtzcGFjZS9naXNlbGFfcG9ydGFsL3NyYy9hcHAvY29tcG9uZW50cy9wb3J0YWwvbGJlLXNldHRpbmcvbGJlLXVwbG9hZC9tb2RhbC1hcm5vbGQvbW9kYWwtYXJub2xkLmNvbXBvbmVudC5jc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vb3B0L2plbmtpbnMvd29ya3NwYWNlL2dpc2VsYV9wb3J0YWwvc3JjL2FwcC9jb21wb25lbnRzL3BvcnRhbC9sYmUtc2V0dGluZy9sYmUtdXBsb2FkL21vZGFsLWFybm9sZC9tb2RhbC1hcm5vbGQuY29tcG9uZW50LmNzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/components/portal/lbe-setting/lbe-upload/modal-arnold/modal-arnold.component.css.shim.ngstyle.ts